<template>
  <div class="topcredit">
    <div class="row mx-0 px-0">
      <div
        :class="(getCustomerType != null && getCustomerType < 1) ? 'col-12 col-sm-12 col-md-12 col-lg-8 text-center text-sm-center text-md-center text-lg-left px-1' : 'col-12 text-center text-sm-center text-md-center text-lg-left px-1'"
      >
        <div class="w-100 py-2 px-3 card">
          <div class="w-100">
            <span class="text-light">
              <small>
                <i class="fas fa-wallet" aria-hidden="true"></i> Credit
              </small>
              :
              <span
                class="badge badge-dark badge-pill text-warning font-weight-normal"
                style="font-size:16px"
              >{{getUsername}}</span>
            </span>
            <h1 class="gold-text main-credit mb-0" data-id="credit_balance">{{getCashAmount.toFixed(2)}} ฿</h1>
          </div>
          <div class>
            <small class="text-light text-shadow">
              <i class="fab fa-product-hunt" aria-hidden="true"></i>
              Reward
            </small>
            <span class="badge badge-light badge-pill ml-1">{{parseInt(getRewardAmount)}} P</span>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-4 px-0" v-if="getCustomerType != null && getCustomerType < 1">
        <div class="row mx-0 px-0 h-100">
          <div class="col-6 col-sm-6 col-md-6 col-lg-12 px-1 pt-1">
            <router-link
              to="/member/deposit"
              class="credit-btn btn golden-btn btn-block btn-lg pb-0 flex-fill"
            >
              <i class="fas fa-plus-circle"></i> เติมเงิน
            </router-link>
          </div>
          <div class="col-6 col-sm-6 col-md-6 col-lg-12 px-1 pt-1">
            <router-link
              to="/member/withdraw"
              class="credit-btn btn silver-btn btn-block btn-lg pb-0 flex-fill"
            >
              <i class="fas fa-minus-circle"></i> ถอนเงิน
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      getCustomerType: "getCustomerType",
      getCashAmount: "getCashAmount",
      getUsername: "getUsername",
      getRewardAmount: "getRewardAmount",
    })
  }
}
</script>

<style lang="scss" scoped>
.topcredit {
  border: rgb(77, 63, 44) 1px solid;
  border-radius: 5px;
  background: url(../assets/images/bg-card-1.jpg) top center no-repeat;
  background-size: cover;
  width: 100%;
  padding: 5px;
  margin: 10px 0;
  box-shadow: rgb(213 173 109 / 30%) 0 0 5px;

  .card {
    background: url(../assets/images/bg-card-1.jpg) center center no-repeat;
    background-size: cover;
    border-radius: 5px;
    border: rgba(75, 75, 75, 0.5) 1px solid;
  }

  .main-credit {
    font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
    -webkit-text-stroke-width: 2px;
    -webkit-text-stroke-color: black;
    font-weight: bold;
  }

  .gold-text {
    color: #d5ad6d;
    background: -webkit-linear-gradient(transparent, transparent),
      -webkit-linear-gradient(top, rgba(213, 173, 109, 1) 0%, rgba(
              213,
              173,
              109,
              1
            )
            26%, rgba(226, 186, 120, 1) 35%, rgba(163, 126, 67, 1) 45%, rgba(
              145,
              112,
              59,
              1
            )
            61%, rgba(213, 173, 109, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .credit-btn {
    display: inline-block;
    outline: none;
    /* font-family: inherit; */
    font-family: SukhumvitBold;
    font-size: 22px;
    box-sizing: border-box;
    border: none;
    border-radius: 0.2em;
    height: auto;
    line-height: 1.9em;
    text-transform: uppercase;
    padding: 3px 0;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    background-size: 100% 100%;
    background-position: center;
  }

  .golden-btn {
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),
      inset 0 -1px 2px 1px rgb(139 66 8), inset 0 -1px 1px 2px rgb(250 227 133);
    background-image: linear-gradient(
      160deg,
      #a54e07,
      #b47e11,
      #fef1a2,
      #bc881b,
      #a54e07
    );
    border: 1px solid #a55d07;
    color: rgb(120, 50, 5);
    text-shadow: 0 2px 2px rgb(250 227 133);
  }

  .silver-btn {
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),
      inset 0 -1px 2px 1px rgb(73 73 73), inset 0 -1px 1px 2px rgb(190 190 190);
    background-image: linear-gradient(
      160deg,
      #525252,
      #8d8a83,
      #d8d8d6,
      #6b6b6b,
      #383838
    );
    border: 1px solid #69645d;
    color: rgb(48, 48, 48);
    text-shadow: 0 2px 2px rgb(190 190 190);
  }
}
</style>
